// extracted by mini-css-extract-plugin
export default {"wrapper":"feedback_wrapper__uAn3d"};